import { FILE_SIZE, FILE_TYPE_REGEX } from './configs';

export const isFilesTypeValid = (files) => files.every((file) => FILE_TYPE_REGEX.test(file.type));

export const isFilesSizeValid = (files) => files.every((file) => file.size <= FILE_SIZE);
